import React from "react";
import { Clock, MapPin, Phone, Mail, MessageCircle, ExternalLink } from "lucide-react";
import { COMPANY, SCHEDULE } from "../data/tarifas";

export default function Footer() {
  return (
    <footer className="border-t border-[#efe4e6] mt-4">
      <div className="max-w-6xl mx-auto px-5 sm:px-8 py-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          <div>
            <h4 className="flex items-center gap-2 font-display font-bold text-[#2a1a1e] mb-3">
              <Clock className="w-4 h-4 text-[#631024]" /> Horario de atención
            </h4>
            <ul className="space-y-1.5 text-sm text-[#6d5a5e]">
              {SCHEDULE.map((s) => (
                <li key={s.day} className="flex justify-between gap-4">
                  <span className="font-semibold text-[#2a1a1e]">{s.day}</span>
                  <span className="text-right">{s.hours}</span>
                </li>
              ))}
            </ul>
            <p className="text-xs text-[#9b8388] mt-3">
              Entrega fuera de horario: +35 € · Entrega a domicilio bajo consulta.
            </p>
          </div>

          <div>
            <h4 className="flex items-center gap-2 font-display font-bold text-[#2a1a1e] mb-3">
              <MapPin className="w-4 h-4 text-[#631024]" /> Dónde estamos
            </h4>
            <p className="text-sm text-[#2a1a1e] font-semibold leading-relaxed">
              {COMPANY.address}
            </p>
            <p className="text-sm text-[#6d5a5e] leading-relaxed">{COMPANY.city}</p>
            <p className="text-sm text-[#6d5a5e] leading-relaxed mt-2">
              Recogida y devolución en nuestras instalaciones, con posibilidad de
              entrega a domicilio bajo consulta.
            </p>
          </div>

          <div>
            <h4 className="flex items-center gap-2 font-display font-bold text-[#2a1a1e] mb-3">
              <Phone className="w-4 h-4 text-[#631024]" /> Contacto
            </h4>
            <ul className="space-y-2.5 text-sm">
              <li>
                <a
                  href={`tel:${COMPANY.telHref}`}
                  className="flex items-center gap-2.5 text-[#6d5a5e] transition-colors hover:text-[#631024]"
                >
                  <Phone className="w-4 h-4 text-[#631024] shrink-0" />
                  Tel. {COMPANY.tel}
                </a>
              </li>
              <li>
                <a
                  href={`mailto:${COMPANY.email}`}
                  className="flex items-center gap-2.5 text-[#6d5a5e] transition-colors hover:text-[#631024]"
                >
                  <Mail className="w-4 h-4 text-[#631024] shrink-0" />
                  {COMPANY.email}
                </a>
              </li>
              <li>
                <a
                  href={`https://wa.me/${COMPANY.mobileHref.replace(/[^0-9]/g, "")}`}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-start gap-2.5 group"
                >
                  <MessageCircle className="w-4 h-4 text-[#631024] shrink-0 mt-0.5" />
                  <span>
                    <span className="block text-xs text-[#9b8388]">Móvil / WhatsApp</span>
                    <span className="font-display font-bold text-[#631024] group-hover:text-[#7a1530] transition-colors">
                      {COMPANY.mobile}
                    </span>
                  </span>
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-[#efe4e6] mt-8 pt-6 flex flex-col sm:flex-row sm:items-start sm:justify-between gap-4">
          <div>
            <p className="font-display font-bold text-[#631024]">
              {COMPANY.name}{" "}
              <span className="font-normal text-[#9b8388] text-sm">
                Alquiler de vehículos · {COMPANY.location}
              </span>
            </p>
            <p className="text-xs text-[#9b8388] mt-2 max-w-3xl">
              Los importes mostrados son orientativos e incluyen la lógica de tarifas
              entre semana, fin de semana y semana completa. El precio final se
              confirma en el momento de la reserva.
            </p>
          </div>
          <a
            href="https://veysa.es/"
            target="_blank"
            rel="noopener noreferrer"
            className="shrink-0 inline-flex items-center justify-center gap-2 rounded-full border border-[#631024] text-[#631024] text-sm font-semibold px-5 py-2.5 transition-all duration-200 hover:bg-[#631024] hover:text-white active:scale-[0.98]"
          >
            Ir a Inicio de VEYSA
            <ExternalLink className="w-4 h-4" />
          </a>
        </div>
      </div>
    </footer>
  );
}
